import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/setting/atom-module',
  title: '原子权限管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
